import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";


import { ArrowLeftColor, BoxMaintenance, BoxPurchases, SharedButton } from "@components";
import { PATH_HOME } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { Spinner } from "@Rocket-Innovation/components/style/loadingStyle";
import { RenderMeta, useNotify } from "@utils";
import { Select } from "antd";
import { m } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { myPurchasesAPI } from "src/API/myPurchases";
import "swiper/components/navigation/navigation.min.css";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentPurchases = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const { warning, error, success } = useNotify();
    const history = useHistory();
    //page props
    const { avatar, fullName, memberTier, isConfirm } = props;
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const [showpage1, setShowPage1] = useState(true);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(false);
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const [viewportHeight, setViewportHeight] = useState(0);
    const [showpopuppage, setShowPopupPage] = useState(true);
    const [assetsData, setAssetsData] = useState<any[]>([]);
    const [maintenancePlanData, setMaintenancePlanData] = useState<any[]>([]);
    const [tab, setTab] = useState<number>(1);
    const [page, setPage] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [brandList, setBrandList] = useState<string[]>(["All Brand"]);
    const [selectedBrand, setSelectedBrand] = useState<string>("All Brand");

    const { Option } = Select;
    const listInnerRef = useRef<HTMLDivElement | null>(null);

    const getBrandList = async () => {
        try {
            const res = await myPurchasesAPI.getBrandList({
                assetType:
                    tab === 1
                        ? "GYM"
                        : tab === 2
                        ? "FURNITURE"
                        : tab === 3
                        ? "HOME"
                        : tab === 4
                        ? "AUDIO"
                        : "GYM",
            });
            if (res.data) {
                setBrandList(["All Brand", ...res.data]);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        setViewportHeight(window.innerHeight);
    }, []);

    useEffect(() => {
        if (tab === 5) {
            getMaintenancePlan();
        } else {
            getAssets();
            getBrandList();
        }
    }, [tab, page, selectedBrand]);

    const getAssets = async () => {
        try {
            setLoading(true);
            const res = await myPurchasesAPI.getAssets({
                assetType:
                    tab === 1
                        ? "GYM"
                        : tab === 2
                        ? "FURNITURE"
                        : tab === 3
                        ? "HOME"
                        : tab === 4
                        ? "AUDIO"
                        : "GYM",
                // brand: selectedBrand === "All Brand" ? "" : selectedBrand,
                brand: tab === 3 ? "Frette" : selectedBrand === "All Brand" ? "" : selectedBrand,
                limit: 10,
                page: page,
            });
            if (res.data?.docs) {
                setAssetsData((prevData) => [...prevData, ...res.data.docs]);
            }
        } catch (err: any) {
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
        } finally {
            setLoading(false);
        }
    };

    const getMaintenancePlan = async () => {
        try {
            setLoading(true);
            const res = await myPurchasesAPI.getMaintenancePlan("");
            if (res.data?.docs) {
                setMaintenancePlanData(res.data?.docs);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseDetail = () => {
        setShowPopup(false);
        closeAllPopup();
    };

    const closeAllPopup = () => {
        setShowPage1(true);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(true);
    };

    const setColor = merchant.themes?.themeColorSecound;
    const setColorSecound = merchant.themes?.themeColorSecound;

    const hexToRgb = (setColor: any) => {
        // Remove the '#' character if present
        setColor = setColor.replace("#", "");

        // Convert the hex code to RGB
        const r = parseInt(setColor.substring(0, 2), 16);
        const g = parseInt(setColor.substring(2, 4), 16);
        const b = parseInt(setColor.substring(4, 6), 16);

        return `linear-gradient(0deg,rgba(${r}, ${g}, ${b}, 0.2) 65%,rgba(${r}, ${g}, ${b}, 1) 100%)`;
    };

    const rgbColor = hexToRgb(setColor);

    const onScroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 10 && !loading) {
                if (page * 10 === assetsData?.length) {
                    setPage((prevPage) => prevPage + 1);
                }
            }
        }
    };

    const onChangeTab = (value: number) => {
        setAssetsData([]);
        setPage(1);
        setSelectedBrand("All Brand");
        setTab(value);
    };

    return (
        <>
            <RenderMeta title={t("meta.purchases_page")} />
            <StyledPurchases
                themeColor={themes?.themeColor!}
                color={rgbColor}
                colorsecound={setColorSecound!}
            >
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor onClick={() => history.push(PATH_HOME)} color="#fff" />
                    </div>
                    <h4>My Purchases</h4>
                </header>
                <div className="main-content">
                    <div className="tab-section">
                        <div
                            className={"tab-item " + (tab === 1 ? "active" : "")}
                            onClick={() => onChangeTab(1)}
                        >
                            Gym
                        </div>
                        <div
                            className={"tab-item " + (tab === 2 ? "active" : "")}
                            onClick={() => onChangeTab(2)}
                        >
                            Furniture
                        </div>
                        <div
                            className={"tab-item " + (tab === 3 ? "active" : "")}
                            onClick={() => onChangeTab(3)}
                        >
                            Home
                        </div>
                        <div
                            className={"tab-item " + (tab === 4 ? "active" : "")}
                            onClick={() => onChangeTab(4)}
                        >
                            Audio
                        </div>
                        <div
                            className={"tab-item " + (tab === 5 ? "active" : "")}
                            onClick={() => setTab(5)}
                        >
                            Maintenance plan
                        </div>
                    </div>
                    {tab !== 3 && tab !== 5 && (
                        <div className="select-purchases">
                            <Select
                                showArrow={false}
                                value={selectedBrand}
                                onChange={(value: any) => {
                                    setPage(1);
                                    setAssetsData([]);
                                    setSelectedBrand(value);
                                }}
                            >
                                {brandList.map((item: any) => (
                                    <Option key={item}>{item}</Option>
                                ))}
                            </Select>
                        </div>
                    )}
                    
                    {tab === 1 &&
                        
                        (assetsData.length > 0 ? (
                            <div
                                className="wrapper-purchases"
                                onScroll={onScroll}
                                ref={listInnerRef}
                            >
                                {assetsData.map((item: any, index: any) => (
                                    <BoxPurchases key={index} data={item} />
                                ))}
                                {loading && (
                                    <div className="loader">
                                        <Spinner color={themes?.themeColor!} />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="nodata">
                                {loading ? (
                                    <div className="loader">
                                        <Spinner color={themes?.themeColor!} />
                                    </div>
                                ) : (
                                    <div>
                                        <p>ยังไม่มีรายการ</p>
                                        <p>No records to display</p>
                                    </div>
                                )}
                            </div>
                        ))

                    }
                    {tab === 2 &&
                        (assetsData.length > 0 ? (
                            <div
                                className="wrapper-purchases"
                                onScroll={onScroll}
                                ref={listInnerRef}
                            >
                                {assetsData.map((item: any, index: any) => (
                                    <BoxPurchases key={index} data={item} />
                                ))}
                                {loading && (
                                    <div className="loader">
                                        <Spinner color={themes?.themeColor!} />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="nodata">
                                {loading ? (
                                    <div className="loader">
                                        <Spinner color={themes?.themeColor!} />
                                    </div>
                                ) : (
                                    <div>
                                        <p>ยังไม่มีรายการ</p>
                                        <p>No records to display</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    {tab === 3 &&
                        (assetsData.length > 0 ? (
                            <div
                                className="wrapper-purchases"
                                onScroll={onScroll}
                                ref={listInnerRef}
                            >
                                {assetsData.map((item: any, index: any) => (
                                    <BoxPurchases key={index} data={item} />
                                ))}
                                {loading && (
                                    <div className="loader">
                                        <Spinner color={themes?.themeColor!} />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="nodata">
                                {loading ? (
                                    <div className="loader">
                                        <Spinner color={themes?.themeColor!} />
                                    </div>
                                ) : (
                                    <div>
                                        <p>ยังไม่มีรายการ</p>
                                        <p>No records to display</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    {tab === 4 &&
                        (assetsData.length > 0 ? (
                            <div
                                className="wrapper-purchases"
                                onScroll={onScroll}
                                ref={listInnerRef}
                            >
                                {assetsData.map((item: any, index: any) => (
                                    <BoxPurchases key={index} data={item} />
                                ))}
                                {loading && (
                                    <div className="loader">
                                        <Spinner color={themes?.themeColor!} />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="nodata">
                                {loading ? (
                                    <div className="loader">
                                        <Spinner color={themes?.themeColor!} />
                                    </div>
                                ) : (
                                    <div>
                                        <p>ยังไม่มีรายการ</p>
                                        <p>No records to display</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    {tab === 5 && (
                        <div className="wrapper-maintenance">
                            {loading && (
                                <div className="loader">
                                    <Spinner color={themes?.themeColor!} />
                                </div>
                            )}
                            {maintenancePlanData.map((item: any, index: any) => (
                                <BoxMaintenance key={index} data={item} />
                            ))}
                        </div>
                    )}
                </div>
            </StyledPurchases>
        </>
    );
};

const StyledPurchases = styled.div<{
    themeColor: string;
    color: string;
    colorsecound: string;
}>`
    width: 100%;
    margin: 0 auto;
    padding: 15px 0 0;
    height: 100vh;
    overflow: scroll;
    background: ${(props) => props.color};
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .loader {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        height: 100px;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        span {
            margin-left: 10px;
            color: ${(props) => (props?.themeColor !== "" ? `${props?.themeColor}` : "#fff")};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .main-content {
        width: 100%;
        height: calc(100% - 64px);
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        background-color: #fff;
        overflow: hidden;
        padding: 16px;
        .tab-section {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 30px;
            gap: 16px;
            .tab-item {
                cursor: pointer;
                font-weight: 600;
                font-size: 15px;
                color: #9b9b9b;
            }
            .active {
                color: #000;
                /* color: ${(p) => p.themeColor}; */
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 50%;
                    height: 4px; /* Adjust the thickness of the border as needed */
                    background: ${(props) => props.colorsecound};
                    border-radius: 5px;
                }
            }
        }
        .select-purchases {
            margin-bottom: 8px;
            .ant-select-single {
                width: 100%;
                .ant-select-selector {
                    border-radius: 0 !important;
                    background-image: url(../../images/ic-select-purchases.svg);
                    background-repeat: no-repeat;
                    background-position: 95% center;
                    background-size: 17px;
                    height: 38px !important;
                    min-height: 38px !important;
                    &:hover {
                        border-color: ${(p) => p.themeColor};
                    }
                }
            }
        }
        .wrapper-maintenance {
            overflow: scroll;
            height: 65vh;
        }
        .box-maintenance {
            border-bottom: 1px solid #f0f0f0;
            padding: 16px 0;
            position: relative;
            padding-left: 85px;
            .img-maintenance {
                position: absolute;
                left: 0;
                top: 16px;
                max-height: 85px;
            }
            .title-maintenance {
                font-size: 14px;
                font-weight: 600;
                line-height: 17px;
                color: #000000;
                margin-bottom: 6px;
            }
            .date-maintenance {
                font-size: 10px;
                line-height: 13px;
                color: #9b9b9b;
                margin-bottom: 6px;
                span {
                    font-size: 12px;
                    line-height: 15px;
                    color: #000;
                    font-weight: 400;
                    margin-left: 5px;
                }
            }
            .visit-maintenance {
                font-size: 10px;
                line-height: 13px;
                color: #9b9b9b;
                margin-bottom: 6px;
                display: inline-block;
                span {
                    font-size: 12px;
                    line-height: 15px;
                    color: #000;
                    font-weight: 400;
                }
                span.point {
                    color: #26c2a4;
                }
                span.fullpoint {
                    color: #e53223;
                }
            }
            .status-maintenance {
                display: inline-block;
                padding: 2px 8px;
                color: #26c2a4;
                background-color: #26c2a412;
                font-size: 11px;
                line-height: 14px;
                margin-left: 6px;
                border-radius: 30px;
            }
        }
        .wrapper-purchases {
            overflow: scroll;
            height: 80dvh;
        }
        .box-purchases {
            border-bottom: 1px solid #f0f0f0;
            padding: 16px 0 24px;
            position: relative;
            padding-left: 135px;
            .img-purchases {
                position: absolute;
                left: 0;
                top: 16px;
                img {
                    max-height: 100px;
                    max-width: 100px;
                    object-fit: cover;
                }
            }
            .title-purchases {
                font-size: 14px;
                font-weight: 600;
                line-height: 17px;
                color: #000000;
                margin-bottom: 6px;
            }
            .desc-purchases {
                margin-bottom: 6px;
                .date {
                    span {
                        margin-right: 6px;
                        img {
                            width: 12px;
                            height: 12px;
                        }
                    }
                    font-size: 12px;
                    line-height: 15px;
                    color: #525257;
                }
                .brand {
                    padding: 2px 8px;
                    background-color: #c4a363;
                    font-size: 11px;
                    line-height: 13px;
                    color: #fff;
                }
                div {
                    position: relative;
                    margin-right: 15px;
                    display: inline-block;
                    &:first-child {
                        &:after {
                            content: "";
                            width: 1px;
                            height: 10px;
                            position: absolute;
                            right: -7px;
                            top: 3px;
                            background-color: #000;
                        }
                    }
                }
            }
            .status-purchases {
                margin-bottom: 26px;
                span {
                    padding: 3px 8px;
                    background-color: #ddd;
                    color: #000000;
                    border-radius: 30px;
                    font-size: 11px;
                    line-height: 14px;
                }
                .shipping {
                    background-color: #ff800b12;
                    color: #ff800b;
                }
                .delivered {
                    background-color: rgba(38, 194, 164, 0.12);
                    color: #26c2a4;
                }
                .obsolete {
                    background-color: rgba(255, 0, 0, 0.12);
                    color: #9b9b9b;
                }
            }

            .detail-purchases {
                font-size: 10px;
                line-height: 13px;
                color: #9b9b9b;
                span {
                    font-size: 12px;
                    line-height: 15px;
                    font-weight: 600;
                    color: #000;
                    margin-left: 5px;
                }
            }
            .view-more {
                position: absolute;
                bottom: 16px;
                right: 0;
            }
        }
    }
`;
const StyledButton = styled(SharedButton)`
    padding: 6px 13px;
    background-color: #000;
    font-size: 12px;
    line-height: 15px;
    color: #fff;
    height: auto;
    width: auto;
`;
const BlurBackground = styled(m.div)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
`;

const StyledUsedBtn = styled.button<{ themeColor: string; themePageColor: string }>`
    padding: 14px 46px;
    /* color: ${(p) => p.themeColor}; */
    color: #fff;
    width: auto;
    /* background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`}; */
    // background: ${(p) => p.theme.colors.card};
    background-color: #000;
    /* border: 0.5px solid ${(p) => p.themeColor}; */
    /* border-radius: 40px; */
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;
const StyledCodeButton = styled.div<{ mainColor?: string; themePageColor: string }>`
    position: absolute;
    background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.mainColor}`};
    // background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;
const StyledShowPopup = styled(m.div)<{ themeColor: string; themePageColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    /* background: rgba(0, 0, 0, 0.5); */
    z-index: 10;
    /* left: 50%; */
    /* transform: translateX(-50%); */
    flex-direction: column;
    justify-content: end;
    /* transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    } */
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        /* animation: bottomtotop 0.5s !important;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            cursor: pointer;
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        position: relative;
        /* animation: bottomtotop 0.5s !important;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            /* background: ${(props) =>
                props?.themePageColor !== ""
                    ? `${props?.themePageColor}`
                    : `${props?.themeColor}`}; */
            // background-color: ${(p) => p.themeColor};
            /* width: 100%; */
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: auto;
        min-height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        /* animation: bottomtotop 0.5s !important; */
        /* @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            /* color: #fff;
            background: ${(props) =>
                props?.themePageColor !== ""
                    ? `${props?.themePageColor}`
                    : `${props?.themeColor}`}; */
            // background-color: ${(p) => p.themeColor};
            /* width: 100%; */
            /* padding: 10px 0; */
            font-size: 13px;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-top: -100px;
            padding-bottom: 20px;
            .result-luckydraw {
                padding: 12px;
                background-color: rgba(51, 108, 81, 0.08);
                border-radius: 12px;
                position: relative;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .result-img-luckydraw {
                    margin-right: 16px;
                    img {
                        width: 100px;
                        height: 100px;
                    }
                }
                .text-giftset {
                    h2 {
                        font-size: 18px;
                        line-height: 21px;
                        color: #000;
                        font-weight: 600;
                    }
                    p {
                        font-size: 12px;
                        line-height: 16px;
                        margin-bottom: 0;
                        color: #9b9b9b;
                    }
                }
            }
            .layout-img {
                text-align: center;
                .img-product {
                    width: 150px;
                    height: 150px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
                /* margin-bottom: 16px; */
                span {
                    padding: 3px 8px;
                    background-color: #ddd;
                    color: #000000;
                    border-radius: 30px;
                    font-size: 11px;
                    line-height: 14px;
                    margin-right: 5px;
                }
                .shipping {
                    background-color: #ff800b12;
                    color: #ff800b;
                }
            }

            .process-product {
                max-width: 200px;
                margin: 10px auto;
                .ant-progress-inner {
                }
                .ant-progress-bg {
                    background-color: ${(p) => p.themeColor};
                }
            }
        }
        .warranty-layout {
            padding-bottom: 18px;
            border-bottom: 1px solid #fcf4e4;
            margin-bottom: 14px;
            .warranty-box {
                padding: 8px 0;
                text-align: center;
                border: 0.5px dashed #c4a363;
                background-color: #c4a36312;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                span {
                    display: block;
                    font-size: 12px;
                    line-height: 15px;
                    color: #c4a363;
                }
            }
        }
        .text-purchases {
            color: #9b9b9b;
            font-size: 12px;
            line-height: 15px;
            text-align: center;
        }
        .btn-purchases {
            margin-top: 24px;
            text-align: center;
        }
        .content-product {
            padding: 16px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            // padding: 10px;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
